import Template00 from "./Template-00"
import Template01 from "./Template-01"
import Template02 from "./Template-02"

export default {
    Template00,
    Template01,
    Template02
}
